/**
 * The Launchpad follow-up list (ADR-127 D17) — paying customers whose snippet is still not live
 * about a week after sign-up, for human outreach. Fanned out to every zone (each zone lists its
 * own domains), merged into ONE zone-agnostic list; the page shows a per-zone legend like the
 * Alerts board.
 */
import { adminApiInZone } from './api-client';
import { fanOutZones, failedZoneLabels, throwIfAllZonesFailed, type PortalZone } from './zones';

export interface FollowUpRow {
  accountId: string;
  domainToken: string;
  hostname: string;
  businessName: string;
  ownerName: string;
  ownerEmail: string;
  signedUpAt: string;
  daysSinceSignUp: number;
  snippetEmailSent: boolean;
  everFired: boolean;
  /** Added by the client after the fan-out. */
  zone?: string;
}

export interface FollowUpResult { rows: FollowUpRow[]; afterDays: number; failedZones: string[] }

export async function listFollowUp(): Promise<FollowUpResult> {
  let afterDays = 7;
  const results = await fanOutZones(async (zone: PortalZone) => {
    const r = await adminApiInZone<{ afterDays: number; rows: FollowUpRow[] }>(zone, '/admin/launchpad/follow-up');
    afterDays = r.afterDays ?? afterDays;
    return r.rows.map((row) => ({ ...row, zone: zone.code }));
  });
  throwIfAllZonesFailed(results);
  return {
    rows: results.flatMap((r) => r.items).sort((a, b) => b.daysSinceSignUp - a.daysSinceSignUp),
    afterDays,
    failedZones: failedZoneLabels(results),
  };
}
